/* global device */

export function isMobileApp () {
  return typeof device !== 'undefined'
}

export function isIOSApp () {
  return typeof device !== 'undefined' && device.platform === 'iOS'
}
